import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const KategorieZarizeni = {
	name: NAME,
	apiProvider,
	router,
};
